import { render } from "./IndexVendor.vue?vue&type=template&id=524efd1c"
import script from "./IndexVendor.vue?vue&type=script&lang=js"
export * from "./IndexVendor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__